import { TypePersonEnums } from 'src/app/enum/type-person-enums';
import { TecnologyProviderEnums } from './../../enum/tecnology-provider-enums';
import { BranchModel } from './branch.model';
export class EnterpriseModel {
  enterpriseId: number = 0;
  branchId: number = 0;
  branch: BranchModel = new BranchModel()
  code: number = 0;
  typeDocumentId: number = 0;
  document: string = '';
  digitVerification: number = 0;
  typePersonId: number = TypePersonEnums.natural;
  names: string | null = null;
  lastNames: string | null = null;
  businessName: string = '';
  businessName2: string | null = null;
  active: boolean = true;
  invoiceObservation: string | null = null;
  invoiceObservation2: string | null = null;
  invoiceObservation3: string | null = null;
  invoiceObservationFooter: string | null = null;
  invoiceText: string | null = null;
  invoiceText2: string | null = null;
  invoiceText3: string | null = null;
  invoiceText4: string | null = null;
  invoiceText5: string | null = null;
  invoiceText6: string | null = null;
  swIvaResponsible: boolean = false;
  swGreatContributor: boolean = false;
  swSimpleTaxRegime: boolean = false;
  swSelfRetainer: boolean = false; //Autoretenedor de Retefuente
  swElectronicInvoice: boolean = false;
  tecnologyProviderId: number = TecnologyProviderEnums.ninguno;
  tecnologyProviderUser: string | null = null;
  tecnologyProviderPassword: string | null = null;
  swStoreInterface: boolean = false;
  logo: string | null = null;
  logoFooter: string | null = null;
  signature: string | null = null;
  discountAccount: string | null = null;
  utilizationAccount: string | null = null;
  refundAccount: string | null = null;
  interestAccount: string | null = null;
  commissionAccount: string | null = null;
  webPage: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
